module.exports = __webpack_public_path__ + "public/images/circular-background-pattern-2.ca3a0e0490a84f6b33122e76cc4fcc5f.svg";